export default {
  main: ["main", "businessAvatar", "nickName", "legalName", "currencyId", "otherCurrencies", "isGregorian"],
  others: [
    "fieldActivity",
    "economicalCode",
    "nationalID",
    "registrationNumber",
    "state",
    "city",
    "postalCode",
    "address",
    "phone",
    "email",
    "webSite",
    "businessType",
    "startDate",
    "endDate",
    "warehouseAccountingSystem",
    "warehouseAnalyzeSystem",
    "fiscalYearTitle",
    "taxRate",
    "calendar",
    "multipleCurrency",
    "warehouseSystem",
    "businessAvatar",
    "fax",
  ],
};
